import { useMutation } from 'react-query';

import { TournamentRegister } from '~/../api/common.types';
import { api } from '~/client/api';

export const useSubmitTournamentRegister = () => {
  return useMutation((data: TournamentRegister) => {
    return api.tournamentRegister(data);
  });
};
